export enum MessageKey {
  INTLAYER_CONFIGURATION = 'INTLAYER_CONFIGURATION',
  INTLAYER_CURRENT_LOCALE = 'INTLAYER_CURRENT_LOCALE',
  INTLAYER_EDITOR_ENABLED = 'INTLAYER_EDITOR_ENABLED',
  INTLAYER_URL_CHANGE = 'INTLAYER_URL_CHANGE',
  INTLAYER_HOVERED_CONTENT_CHANGED = 'INTLAYER_HOVERED_CONTENT_CHANGED',
  INTLAYER_FOCUSED_CONTENT_CHANGED = 'INTLAYER_FOCUSED_CONTENT_CHANGED',
  INTLAYER_LOCALE_DICTIONARIES_CHANGED = 'INTLAYER_LOCALE_DICTIONARIES_CHANGED',
  INTLAYER_DISTANT_DICTIONARIES_CHANGED = 'INTLAYER_DISTANT_DICTIONARIES_CHANGED',
  INTLAYER_EDITED_CONTENT_CHANGED = 'INTLAYER_EDITED_CONTENT_CHANGED',
  INTLAYER_IFRAME_CLICKED = 'INTLAYER_IFRAME_CLICKED',
}
